// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eg1Wu","colBig":"styles_colBig__1Gil1","colSmall":"styles_colSmall__2O7Lu","shopifyNameWrapper":"styles_shopifyNameWrapper__2nSrd"};